import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const ACTIVELY_SEEKING_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

export function isActivelySeekingRecent(activelySeekingUpdatedAt?: string | null): boolean {
  if (!activelySeekingUpdatedAt) return false;
  return new Date(activelySeekingUpdatedAt) >= new Date(Date.now() - ACTIVELY_SEEKING_WINDOW_MS);
}

const EXPERIENCE_TAILWIND_CLASSES: Record<string, string> = {
  "0-2 years":   "text-zinc-200",
  "2-5 years":   "text-emerald-500",
  "5-8 years":   "text-sky-500",
  "8-12 years":  "text-violet-500",
  "12-18 years": "text-orange-500",
  "18+ years":   "text-rose-500",
};

export function getExperienceTailwindClass(experience?: string | null): string {
  return (experience && EXPERIENCE_TAILWIND_CLASSES[experience]) ?? "text-zinc-200";
}

/**
 * Returns days remaining until the Actively Seeking badge expires.
 * Positive = still active, 0 or negative = already expired.
 * Returns null if the badge was never set.
 */
export function seekingExpiresIn(activelySeekingUpdatedAt?: string | null): number | null {
  if (!activelySeekingUpdatedAt) return null;
  const expiresAt = new Date(activelySeekingUpdatedAt).getTime() + ACTIVELY_SEEKING_WINDOW_MS;
  return Math.ceil((expiresAt - Date.now()) / 86400000);
}
